import { useEffect, useState } from "react";
import LayoutSubmasterToUser from "../../components/layoutConfig/layoutSubmasterToUser";
import LocalStorage from "../../helpers/localstorage";
import { setupAPIclient } from "../../services/setupAPIclient";
import AgendaWorkspace, { AgendaDoc } from "../../components/agenda/AgendaWorkspace";

export default function AgendaPageSubmaster() {
  const [docs, setDocs] = useState<AgendaDoc[]>([]);
  const [loading, setLoading] = useState(true);

  const localStorage = new LocalStorage();
  const token = String(localStorage.getAuthTokenUserToSubmaster());

  useEffect(() => {
    const load = async () => {
      try {
        const api = setupAPIclient(token);
        const res = await api.post("/management/get/dashboard");
        setDocs(res.data.docs || []);
      } catch (error) {
        console.error("Erro ao carregar agenda:", error);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [token]);

  return (
    <LayoutSubmasterToUser>
      <AgendaWorkspace docs={docs} loading={loading} />
    </LayoutSubmasterToUser>
  );
}
